<template>
  <div class="orderList" :class="sendList.length >3  ? '' : 'ht'">
       <router-view @priceList="priceList"></router-view>
  </div>
</template>

<script>
export default {
  created() {
  },
  data() {
    return {
      orderId:'' ,
      sendList:[]
    }
  },
  methods:{
    leave(){
      this.$router.push('/orderList')
    },
    priceList(list){
      this.sendList = list
    }
  }

}
</script>

<style scoped>
</style>